// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1FinY","insightsList":"newBusinessInsightsMenu_insightsList__hjSBI","active":"newBusinessInsightsMenu_active__HSUZ6"};